import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux';

import filterReducer, {
  categoryMappingReducer,
} from '../containers/Filter/reducer';

const rootReducer = combineReducers({
  filter: filterReducer,
  categoryMapping: categoryMappingReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
